import http from '@/plugins/http';
import { useAccountStore } from '@/stores/account';
import reportError from '@/utils/reportError';

export default (params) => new Promise((res, rej) => {
  const data = {
    video_id: params.videoId,
  };

  http.put(`/v3/users/${useAccountStore().id}/arcade_seen`, data)
    .then((response) => {
      res(response);
    })
    .catch((error) => {
      rej(error);
      reportError(error, 'video seen error');
    });
});
